import {campaignService} from "@/modules/common/services";

const state = {
  campaignsSuggestions: null,
}

const getters = {
  campaignsSuggestions: state => {
    return state.campaignsSuggestions
  }
}

const mutations = {
  setCampaignsSuggestions : (state,campaignsSuggestions) => {
    state.campaignsSuggestions = campaignsSuggestions
  }
}

const actions = {
  fetchCampaignsSuggestions : async ({commit}, payload) => {
    try {
      const campaignSuggestions = await campaignService.getCampaignSuggestions('campaigns')
      commit('setCampaignsSuggestions',campaignSuggestions.data)
    } catch (e) {
      console.log("fetchCampaigns", e)
    }
  },
  cloneSuggestion : async ({commit}, campaignUid) => {
    try {
      return await campaignService.cloneSuggestion(campaignUid)
    } catch (e) {
      console.log("fetchCampaigns", e)
    }
  },
  getCampaign : async ({commit}, campaignUid) => {
    try {
      return await campaignService.getCampaign(campaignUid)
    } catch (e) {
      console.log("fetchCampaigns", e)
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
